export default "__VITE_ASSET__CJj$R_9T__"